import { render, staticRenderFns } from "./SystemLogs.vue?vue&type=template&id=1baa2290&"
import script from "./SystemLogs.vue?vue&type=script&lang=js&"
export * from "./SystemLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports